<template>
  <BTabs pills>

    <BTab id="general" active>
      <template #title>
        <FeatherIcon icon="HomeIcon" size="16" class="mr-0 mr-sm-50" />
        <span class="d-none d-sm-inline">Datos generales</span>
      </template>

      <StudentsViewTabGeneralAvatar v-if="student"/>

      <StudentsViewTabGeneralData v-if="student"/>
    </BTab>

    <BTab id="lessons" @click="showTabInvoices=true">
      <template #title>
        <FeatherIcon icon="ClockIcon" size="16" class="mr-0 mr-sm-50" />
        <span class="d-none d-sm-inline">Gastos</span>
      </template>

      <StudentsViewTabInvoices v-if="student && showTabInvoices"/>
    </BTab>

    <BTab id="grades" @click="showTabEnrollments=true">
      <template #title>
        <FeatherIcon icon="ClipboardIcon" size="16" class="mr-0 mr-sm-50" />
        <span class="d-none d-sm-inline">Matrículas</span>
      </template>
      <StudentsViewTabEnrollments v-if="student && showTabEnrollments"/>
    </BTab>
  </BTabs>
  </template>
  <script>
  import { BTab, BTabs, BCard, BAlert, BLink, } from 'bootstrap-vue'
  import { ref, onUnmounted, provide, watch} from '@vue/composition-api'
  import store from '@/store'
  import dateUtils from '@/hooks/dateUtils' 
  import currency from '@/utils/currency'
  import popups from '@/hooks/popups'
  import ability from '@/libs/acl/ability'
  import axios from '@axios'
  import router from '@/router'
  import { getStudent } from '@/composables/studentService'
  import StudentsViewTabGeneralData from './StudentsViewTabGeneralData'
  import StudentsViewTabGeneralAvatar from './StudentsViewTabGeneralAvatar'
  import StudentsViewTabInvoices from './StudentsViewTabInvoices'
  import StudentsViewTabEnrollments from './StudentsViewTabEnrollments'


  export default {
    components: { BTab, BTabs, BCard, BAlert, BLink, StudentsViewTabGeneralData, StudentsViewTabGeneralAvatar, StudentsViewTabInvoices, StudentsViewTabEnrollments}, 
    setup() {

      const { formatCurrency } = currency()
      const { formatDate } = dateUtils()
      const { deletePopup } = popups();
      const student = ref(null)
      const termsCourse=ref(null)
      const cursoMensual=ref(null)
      const reRenderKey = ref(0)
      const showTabEnrollments = ref(false)
      const showTabInvoices = ref(false)
      const showTabEvaluations = ref(false)
      
      const fetchStudent = async function () {
        let response = await getStudent(router.currentRoute.params.id)
        student.value= response.data.student
        student.value.enrollments.forEach(enrol => enrol.view_more =  '' )
      }

      fetchStudent()

      provide('student', student)

      return {
        showTabEnrollments,
        showTabInvoices,
        showTabEvaluations,
        student
      }
    },
  }
  </script>
  
  <style>
  
  </style>
  